module.exports = __webpack_public_path__ + "static/media/spot23.bb6782fc.webp";